import React, { useEffect, useState } from 'react';
import { Modal } from 'Components/Modal';
import { PillButton } from 'Components/Fields/Buttons';
import { trackPage, trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { profileSDK } from 'Utils/ProfileSDK';
import { logError } from 'Utils/Logger';
import deviceNameMap from './deviceNameMap';
import './deviceRegistrationModal.css';

export const DeviceRegistrationModal = ({ onClose, onSuccess, devices = [], loginInfo = {} }) => {
  const sortedDevices = devices.sort((a, b) => b.last_modified - a.last_modified);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const signOutAllDevicesBtn = 'Sign Out of All Devices';
  const signOutSelectedDevicesBtn = 'Sign Out of Selected Devices';

  useEffect(() => {
    trackPage('Device Limit Reached Landing', window.location.pathname, 'device_limit_reached_landing');
  }, []);

  const selectDevice = (sid) => {
    return () => {
      const newSelDevices = [...selectedDevices];
      const selectedDevice = devices.find((device) => device.sid === sid);
      if (newSelDevices.indexOf(sid) > -1) {
        newSelDevices.splice(newSelDevices.indexOf(sid), 1);
        trackEvent(TRACKING_ENUMS.EVENT_BUTTON_LINK_UNSELECTED, {
          page_button_text: renderDeviceName(selectedDevice.device),
          page_name: 'account:limit',
          page_type: 'device limit',
        });
      } else {
        newSelDevices.push(sid);
        trackEvent(TRACKING_ENUMS.EVENT_BUTTON_LINK_SELECTED, {
          page_button_text: renderDeviceName(selectedDevice.device),
          page_name: 'account:limit',
          page_type: 'device limit',
        });
      }
      setSelectedDevices(newSelDevices);
    };
  };

  const renderDateString = (dateStr) => {
    const date = new Date(dateStr * 1000);
    return date.toLocaleDateString('en-US');
  };

  const renderDeviceName = (name) => {
    return deviceNameMap[name] || 'Unknown device';
  };

  const renderDeviceList = () => {
    return (
      <table className="deviceList">
        <thead>
          <tr>
            <th></th>
            <th className="deviceList__name">Device Names</th>
            <th className="deviceList__lastSignIn">Last Sign In</th>
          </tr>
        </thead>
        <tbody>
          {sortedDevices.map((item) => {
            const checked = selectedDevices.indexOf(item.sid) > -1;
            const id = `deviceList__item__${item.sid}`;
            return (
              <tr key={item.sid}>
                <td className="deviceList__checkbox">
                  <input
                    id={id}
                    className={`deviceList__checkbox__input`}
                    type="checkbox"
                    checked={checked}
                    onChange={selectDevice(item.sid)}
                  />
                </td>
                <td className="deviceList__name">{renderDeviceName(item.device)}</td>
                <td className="deviceList__lastSignIn">{renderDateString(item.last_modified)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const signOutOfDevices = (allDevices = false, buttonText) => {
    return async () => {
      const accountInfo = {
        email: loginInfo.email,
        password: loginInfo.password,
        userType: 'email',
      };
      const sids = allDevices ? sortedDevices.map((item) => item.sid) : selectedDevices;
      setIsSubmitting(true);
      trackEvent(TRACKING_ENUMS.EVENT_BUTTON_LINK_SELECTED, {
        page_button_text: buttonText,
        page_name: 'account:limit',
        page_type: 'device limit',
      });
      try {
        await profileSDK().deleteSessions({ accountInfo, sids });
        setIsSubmitting(false);
        onSuccess();
      } catch (error) {
        logError(error);
        setIsSubmitting(false);
      }
    };
  };

  return (
    <Modal isShowing={true} onClose={onClose} customClass="deviceRegistrationModal">
      <div className="wrapper">
        <div className="header">Device Limit Reached</div>
        <div className="content">
          <div className="message">
            Too many devices are using this account right now. Sign out from two or more of these devices to continue
            watching:
          </div>
          {renderDeviceList()}
          <div className="modalButtons">
            <PillButton
              text={signOutAllDevicesBtn}
              onClick={signOutOfDevices(true, signOutAllDevicesBtn)}
              submitting={isSubmitting}
            />
            <PillButton
              text={signOutSelectedDevicesBtn}
              onClick={signOutOfDevices(false, signOutSelectedDevicesBtn)}
              isDisabled={selectedDevices.length < 2}
              submitting={isSubmitting}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
